import { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';
import { SelectAddress } from '../../../interfaces/address/select-address.interface';

export const SELECT_ADDRESS_COMPONENT_TYPE = new InjectionToken<ComponentType<SelectAddress>>('SELECT_ADDRESS');
